"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _SwipeableDrawer = _interopRequireDefault(require("@material-ui/core/SwipeableDrawer"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Burger = _interopRequireDefault(require("../../Icons/Burger"));

var _MobileHeader = _interopRequireDefault(require("../../MobileHeader"));

var _TouchableOpacity = _interopRequireDefault(require("../../TouchableOpacity"));

var _Links = _interopRequireDefault(require("./Links"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _HomeLink = _interopRequireDefault(require("./HomeLink"));

var _useIsIos = _interopRequireDefault(require("./useIsIos"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return {
    links: {
      zIndex: 1
    },
    header: {
      zIndex: -1,
      margin: spacing(-8, 0, 0)
    },
    paper: {
      backgroundColor: 'transparent',
      boxShadow: 'unset'
    },
    backdrop: {
      backgroundColor: 'rgba(0,21,41,0.65)'
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2["default"]];
});

var Menu = function Menu(props) {
  var _props$LogoProps = props.LogoProps,
      LogoProps = _props$LogoProps === void 0 ? {} : _props$LogoProps,
      children = props.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var classes = useStyles();
  var t = (0, _useTranslation["default"])();
  var iOS = (0, _useIsIos["default"])();
  var handleOnOpen = (0, _react.useCallback)(function () {
    return setOpen(true);
  }, []);
  var handleOnClose = (0, _react.useCallback)(function () {
    return setOpen(false);
  }, []);
  return (0, _core.jsx)(_react["default"].Fragment, null, (0, _core.jsx)(_TouchableOpacity["default"], {
    "data-testid": "BurgerMenu",
    "aria-label": open ? t('close_menu') : t('open_menu'),
    onClick: handleOnOpen
  }, (0, _core.jsx)(_Icon["default"], {
    as: _Burger["default"],
    color: "primary",
    size: 8
  })), (0, _core.jsx)(_styles.StylesProvider, {
    injectFirst: true
  }, (0, _core.jsx)(_SwipeableDrawer["default"], {
    anchor: "top",
    open: open,
    disableBackdropTransition: !iOS,
    onOpen: handleOnOpen,
    onClose: handleOnClose,
    PaperProps: {
      style: classes.paper
    },
    BackdropProps: {
      style: classes.backdrop
    }
  }, (0, _core.jsx)(_Links["default"], null, (0, _core.jsx)(_HomeLink["default"], LogoProps), children), (0, _core.jsx)(_MobileHeader["default"], {
    css: classes.header
  }, (0, _core.jsx)("span", null)))));
};

__signature__(Menu, "useState{[open, setOpen](false)}\nuseStyles{classes}\nuseTranslation{t}\nuseIsIos{iOS}\nuseCallback{handleOnOpen}\nuseCallback{handleOnClose}", function () {
  return [useStyles, _useTranslation["default"], _useIsIos["default"]];
});

var _default = Menu;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Menu.tsx");
  reactHotLoader.register(Menu, "Menu", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Menu.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/Menu.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();